import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const forgotPasswordApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    forgotPassword: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/send-change-pwd-link',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
  overrideExisting: 'throw',
});
